import { Alert, AlertProps, AlertTitle } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

const StyledAlert = styled(Alert)({
  '&:active': {
    opacity: 0.9,
    transform: 'scale(0.99)',
  },
  '&:hover': {
    cursor: 'pointer',
    opacity: 0.95,
  },
  'transition': 'transform 0.2s, opacity 0.2s',
})

interface TopAlertProps {
  severity?: AlertProps['severity']
  variant?: AlertProps['variant']
  title: string
  content: string | string[]
  onClick: () => void
}

const TopAlert: React.FC<TopAlertProps> = ({
  content,
  onClick,
  severity = 'error',
  title,
  variant,
}) => {
  const items = typeof content === 'string' ? [content] : content

  return (
    <StyledAlert className="noselect" variant={variant} severity={severity} onClick={onClick}>
      <AlertTitle>{title}</AlertTitle>
      <ul style={{ marginBottom: 0 }}>
        {items?.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    </StyledAlert>
  )
}

export { TopAlert }
